import { useEffect, useState } from "react";
import { fetchProcessedHistory } from "../api";
import { parseProcessedHistory } from "../utils/parsers";

// Loads the per-date history blocks (all dates when `date` is null)
// while `enabled`. status: "idle" | "loading" | "ready" | "error"
export default function useProcessedHistory(enabled, date) {
  const [blocks, setBlocks] = useState([]);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setStatus("loading");
    setError(null);

    fetchProcessedHistory(date)
      .then((data) => {
        if (cancelled) return;
        setBlocks(parseProcessedHistory(data));
        setStatus("ready");
      })
      .catch((err) => {
        if (cancelled) return;
        setBlocks([]);
        setStatus("error");
        setError(err?.message || "Request failed");
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, date]);

  return { blocks, status, error };
}
